import React, { useContext, useState } from "react";
import classNames from "classnames";
import { ConnectionMode } from "Services/API/API";
import { ButtonProps, SpinningButton } from "Components/ReactstrapSlim";
import { ConnectionsContext } from "./ConnectionsContext";
import classes from "./FollowButton.module.scss";


export type FollowButtonProps = ButtonProps & {
   targetMemberId: Guid
}

export const FollowButton: React.FC<FollowButtonProps> = React.forwardRef<HTMLButtonElement, FollowButtonProps>(({ 
   targetMemberId, className, onClick, color = "primary", ...rest }, ref) => {
   const connectionsContext = useContext(ConnectionsContext);
   const connection = connectionsContext.connections.find(c => c.targetId == targetMemberId);
   const isFollowing = !!connection && connection.connectionMode == ConnectionMode.Following;   
   const [isLoading, setIsLoading] = useState(false);
   const [isHover, setIsHover] = useState(false);

   const onAction = async (e: React.MouseEvent<HTMLButtonElement>) => {
      setIsLoading(true);
      try
      { 
         if(isFollowing)
            await connectionsContext.unfollow(targetMemberId);
         else
            await connectionsContext.follow(targetMemberId);
         if(onClick)
            onClick(e);
      }
      finally {
         setIsLoading(false);
      }
   }

   const onHover = () => {
      setIsHover(wasHover => !wasHover)
   }

   return <SpinningButton 
   ref={ref}   
   className={classNames(classes.cta, className)}
   onClick={onAction} 
   isLoading={isLoading}    
   color={color}
   onMouseEnter={onHover} 
   onMouseLeave={onHover} 
   {...rest}>
      <span className={classes.hiddenPlacheolder}>Wwwwwwww</span>
      <span className={classes.ctaText}>{isFollowing ? 
         isHover ? "Unfollow" : "Following" 
         : "Follow"}</span>
   </SpinningButton>
});